/**
 * Recursively merge key/values from the second object to the first, but
 * only if the keys do not exist on the first.
 */
export default function optionalMerge<T>(obj1: T, obj2: Partial<T>): T {
  for (const key in obj2) {
    const value1 = obj1[key];
    const value2 = obj2[key];
    if (!obj1.hasOwnProperty(key)) {
      obj1[key] = value2;
    } else if (
      value1 &&
      value2 &&
      typeof value1 === "object" &&
      typeof value2 === "object"
    ) {
      optionalMerge(value1, value2);
    }
  }
  return obj1;
}

/**
 * Recursively merge key/values from the second object to the first, but
 * only if the keys do not exist on the first, or are nullish.
 */
export function nullishMerge<T, U>(obj1: T, obj2: U): T & U {
  for (const key in obj2) {
    const value1 = (obj1 as T & U)[key];
    const value2 = (obj2 as T & U)[key];
    if (((obj1 as T & U)[key] ?? null) === null) {
      (obj1 as T & U)[key] = value2;
    } else if (
      value1 &&
      value2 &&
      typeof value1 === "object" &&
      typeof value2 === "object" &&
      !Array.isArray(value1)
    ) {
      nullishMerge(value1, value2);
    }
  }
  return obj1 as T & U;
}
